import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { _Cart_Update } from "../../../store/actions/cart_actions";
import {
  useCheckoutLinesAddMutation,
  useCheckoutLinesUpdateMutation,
  useCreateCheckoutMutation,
  usePaymentGatewayInitializeMutation,
} from "../../../saleor/api";
import {
  set_checkout_id,
  set_payment_options,
} from "../../../store/actions/login_actions";
import { calculator, showAllErrors } from "../../../base/utils";
import { CartItemTransformer } from "../../../services/objectTransformer/cart";
import { Note } from "../../../helbest";
import { useLangNavigate } from "../../../hooks/useLangNavigate";
import { useTranslation } from "react-i18next";

const useProductItem = () => {
  const { i18n } = useTranslation();
  const navigate = useLangNavigate();
  const dispatch = useDispatch();
  const store = useSelector((state) => state);
  const [shareModal, setShareModal] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [createCheckoutMutation] = useCreateCheckoutMutation();
  const [checkoutLinesAddMutation] = useCheckoutLinesAddMutation();
  const [checkoutLinesUpdateMutation] = useCheckoutLinesUpdateMutation();
  const [paymentGatewayInitializeMutation] =
    usePaymentGatewayInitializeMutation();

  const HideModal = () => {
    setIsModalVisible(false);
  };
  const showModal_visible = () => {
    setIsModalVisible(true);
  };

  const add_to_cart = (productItem) => {
    if (store.Login.is_login) {
      const currentCartItem = store.Cart.find(
        ({ product }) => product.id === productItem.id,
      );
      setAddLoading(true);
      if (!store.Login.checkoutId) {
        createCheckoutMutation({
          variables: {
            input: {
              channel: store.Login.channel,
              lines: productItem.variants.map(({ id: variantId }) => ({
                variantId,
                quantity: 1,
                metadata: [
                  {
                    key: "cid",
                    value: store.Login.cid || "",
                  },
                  {
                    key: "cpid",
                    value: store.Login.cpid || "",
                  },
                ],
              })),
              languageCode: i18n.language.toLocaleUpperCase(),
            },
          },
          onCompleted: (response) => {
            if (!response.checkoutCreate.errors.length) {
              dispatch(
                set_checkout_id({
                  checkout_id: response.checkoutCreate.checkout.id,
                }),
              );
              dispatch(
                _Cart_Update(
                  response.checkoutCreate.checkout.lines.map((line) =>
                    CartItemTransformer(line),
                  ),
                ),
              );
              calculator();

              
              const gateways = response.checkoutCreate.checkout.availablePaymentGateways;
              if (gateways?.length) {
                paymentGatewayInitializeMutation({
                  variables: {
                    id: response.checkoutCreate.checkout.id,
                    paymentGateways: gateways.map((gateway) => ({ id: gateway.id })),
                  },
                  onCompleted: (response) => {
                    if (!response.paymentGatewayInitialize.errors.length) {
                      dispatch(set_payment_options(response.paymentGatewayInitialize.gatewayConfigs));
                    } else {
                      showAllErrors(response.paymentGatewayInitialize.errors);
                    }
                  },
                });
              } else {
                dispatch(set_payment_options([]));
              }

              setAddLoading(false);
              Note.success("Product added successfully");
            } else {
              setAddLoading(false);
              showAllErrors(response.checkoutCreate.errors);
            }
          },
        });
      } else {
        if (!currentCartItem) {
          checkoutLinesAddMutation({
            variables: {
              id: store.Login.checkoutId,
              lines: productItem.variants.map(({ id: variantId }) => ({
                variantId,
                quantity: 1,
                metadata: [
                  {
                    key: "cid",
                    value: store.Login.cid || "",
                  },
                  {
                    key: "cpid",
                    value: store.Login.cpid || "",
                  },
                ],
              })),
            },
            onCompleted: (response) => {
              setAddLoading(false);
              if (!response.checkoutLinesAdd.errors.length) {
                dispatch(
                  _Cart_Update(
                    response.checkoutLinesAdd.checkout.lines.map((line) =>
                      CartItemTransformer(line),
                    ),
                  ),
                );
                calculator();
                Note.success("Product added successfully");
              } else {
                showAllErrors(response.checkoutLinesAdd.errors);
              }
            },
          });
        } else {
          checkoutLinesUpdateMutation({
            variables: {
              id: store.Login.checkoutId,
              lines: [
                {
                  quantity: currentCartItem?.product?.quantity + 1,
                  lineId: currentCartItem.id,
                },
              ],
            },
            onCompleted: (response) => {
              setAddLoading(false);
              if (!response.checkoutLinesUpdate.errors.length) {
                dispatch(
                  _Cart_Update(
                    response.checkoutLinesUpdate.checkout.lines.map((line) =>
                      CartItemTransformer(line),
                    ),
                  ),
                );
                calculator();
                Note.success("Product added successfully");
              } else {
                showAllErrors(response.checkoutLinesUpdate.errors);
              }
            },
          });
        }
      }
    } else {
      localStorage.setItem("pending_cart_item", JSON.stringify(productItem));
      navigate("/login/");
    }
  };

  const add_pending_cart_item = () => {
    const raw = localStorage.getItem("pending_cart_item");
    if (!raw) return;

    const productItem = JSON.parse(raw);
    localStorage.removeItem("pending_cart_item");
    add_to_cart(productItem);
    navigate("/cart/");
  };

  return {
    shareModal,
    setShareModal,
    isModalVisible,
    HideModal,
    showModal_visible,
    add_to_cart,
    add_pending_cart_item,
    store,
    addLoading,
  };
};

export default useProductItem;
